import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import cx from 'classnames'
import PropTypes from 'prop-types'

import classNames from './styles.module.scss'


Arrow.propTypes = {
  position: PropTypes.oneOf(['left', 'right']).isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
}

export default function Arrow({
  position,
  className = undefined,
  style = undefined,
  onClick = undefined,
}) {
  return (
    <FontAwesomeIcon
      icon={`chevron-${position}`}
      className={cx(className, classNames.arrow, classNames[`arrow-${position}`])}
      style={style}
      onClick={onClick}
    />
  )
}
